/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import SelectCustomer from "../../components/SelectCustomer";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES } from "../../utils/constants";
import FormVanBan from "./formVanBan";

const ALLVALUE = { ma: "ALL", ten: "Tất cả", id: "ALL" };
const optionTrangThaiVanBan = [
  {
    id: 1,
    ten: "Còn hiệu lưc",
  },
  {
    id: 2,
    ten: "Hết hiệu lực một phần",
  },
  {
    id: 3,
    ten: "Hết hiệu lực toàn phần",
  },
];
function QuanLyVanBan() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState([]);
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [optionLoaiVanBan, setOptionLoaiVanBan] = useState([]);
  const [paramsFetchData, setParamsFetchData] = useState({
    loaivanban: ALLVALUE.id,
    // tinhtrang: ALLVALUE.id,
  });

  const handleChangeFilter = (keyName) => (e) => {
    let { value } = e.target;
    setParamsFetchData((prev) => ({
      ...prev,
      [keyName]: value,
    }));
  };

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.VANBAN + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      // setTableData([...tableData]);
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.VANBAN + "/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        let rowAdd = response.data;
        fetchData(paramsFetchData, pagination);
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          API_ROUTES.VANBAN,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        fetchData(paramsFetchData, {
          pageIndex: 0,
          pageSize: pagination?.pageSize,
        });
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };

  // Lấy toàn bộ dữ liệu theo năm, tỉnh, huyện, loại doanh nghiêp, cấp quản lý
  const fetchData = async ({ loaivanban }, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        loaivanban: loaivanban == ALLVALUE.id ? null : loaivanban,
        // tinhtrang: tinhtrang == ALLVALUE.id ? null : tinhtrang,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.VANBAN, {
        params: body,
      });
      setTableData(response.data?.vanban);
      setRowCount(response.data?.totalRecord);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(paramsFetchData, pagination);
  }, [paramsFetchData, pagination]);

  useEffect(() => {
    const fetchDataLoaiVanBan = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.LOAIVANBAN);
        setOptionLoaiVanBan(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataLoaiVanBan();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "sovanban",
        header: "Số văn bản",
        size: 150,
      },
      {
        accessorKey: "loaivanban_ten",
        header: "Loại văn bản",
        size: 150,
      },
      {
        accessorKey: "ngaybanhanh",
        header: "Ngày ban hành",
        size: 200,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value && dayjs(value)?.isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : "";
        },
      },
      {
        accessorKey: "nguoiky",
        header: "Người ký",
        size: 150,
      },
      {
        accessorKey: "coquanbanhanh",
        header: "Cơ quan ban hành",
        size: 200,
      },
      {
        accessorKey: "tinhtrang_ten",
        header: "Tình trạng",
        size: 150,
      },
    ],
    []
  );

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.VANBAN + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa văn bản");
    setValidationErrors({});
    setModalOpen(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <SelectCustomer
              keyValue="loaivanban"
              label="Loại văn bản"
              labelName="ten"
              option={optionLoaiVanBan}
              onChange={handleChangeFilter("loaivanban")}
              state={paramsFetchData.loaivanban}
              unicode="id"
            />
          </Grid>
          {/* <Grid item xs={12} md={6} lg={6}>
            <SelectCustomer
              keyValue="tinhtrang"
              label="Tình trạng"
              labelName="ten"
              option={optionTrangThaiVanBan}
              onChange={handleChangeFilter("tinhtrang")}
              state={paramsFetchData.tinhtrang}
              unicode="id"
            />
          </Grid> */}
        </Grid>
      </MDBox>
      <MDBox py={3}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 90,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex", flexWrap: "nowrap" }}>
              <Tooltip arrow placement="left" title="Chỉnh sửa">
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Xoá">
                <IconButton
                  color="primary"
                  onClick={() => {
                    let _data = [];
                    _data["id"] = row.getValue("id");
                    _data["sovanban"] = row.getValue("sovanban");
                    handleOpenDeleteConfirmation(_data);
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ color: "#ffffff" }}
                onClick={() => {
                  setAction("New");
                  setTitle("Thêm mới văn bản");
                  setDataRow({});
                  setValidationErrors({});
                  setModalOpen(true);
                }}
              >
                Tạo mới
              </Button>
            </Stack>
          )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <FormVanBan
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataTinhTrang={optionTrangThaiVanBan}
          dataLoaiVanBan={optionLoaiVanBan}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá số văn bản: {selectedRow?.sovanban} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default QuanLyVanBan;
